"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTERNAL_SHOP_FEED_PLUGINS = void 0;
exports.EXTERNAL_SHOP_FEED_PLUGINS = {
    GOOGLE_SHOPPING: 'GOOGLE_SHOPPING',
    FACEBOOK_CATALOG: 'FACEBOOK_CATALOG'
};
//# sourceMappingURL=externalShopFeedPlugins.js.map